// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05bf9d38","455":"93fbcca1","977":"4abe73e7"}[chunkId] + ".chunk.js";
};